import * as types from "../mutation-types";

// initial state
const state = {
  processo: null,
};

// actions
const actions = {
  atualizarProcessoAutos({ commit }, {processo}) {
    commit(types.ATUALIZAR_PROCESSO_AUTOS, {processo});
  },
  limparProcessoAutos({ commit }) {
    commit(types.LIMPAR_PROCESSO_AUTOS);
  },
};

const mutations = {
  [types.ATUALIZAR_PROCESSO_AUTOS](state, {processo}) {
    state.processo = processo;
  },
  [types.LIMPAR_PROCESSO_AUTOS](state) {
    state.processo = null;
  },
};

export default {
  state,
  actions,
  mutations,
};
